<template>
    <div v-if="enabled===true" class="date_time_sequencer">
        <div class="card card-cascade narrower mb-r">
            <div class="view gradient-card-header pt-3 pb-3 primary-color">
                <h4 class="white-text mb-0">
                    {{labels.main}}
                    <pop_over class="" ref="pop_over" :id="popoverId" :content="popoverContent"></pop_over>
                </h4>
            </div>
            <div class="card-body">
                <!--the global switch-->
                <div class="d-flex flex-column"
                     v-if="(effect_global.hasOwnProperty('active') && effect_global.active == true)">
                    <div class="d-flex flex-row">
                        <div>Enable global overwrite</div>
                        <div>
                            <div class="switch">
                                <label>
                                    <input type="checkbox" name="open_close_full--global" v-model="global_switch_model">
                                    <span class="lever"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div role="alert"
                         class="alert alert-danger fade show">
                        <h6><i class="material-icons">warning</i> <strong>Warning!</strong></h6>
                        <div v-html="effect_global.text"></div>
                    </div>
                </div>
                <div v-if="!(effect_global.hasOwnProperty('active') && effect_global.active == true)">
                    <div v-html="labels.description" role="alert" class="fade show" :class="labels.class"></div>
                </div>
                <div>
                    <!--the messages notifier-->
                    <div class="d-flex flex-column">
                        <!--and finally the forms-->
                        <div>
                            <div class="row">
                                <!--open_date-->
                                <div class="col-sm-7" v-if="is_data_entry==true">
                                    <div class="md-form">
                                        <i class="material-icons prefix"
                                           :class="[elms.open.date.element.elmClass.icon]">calendar_today</i>
                                        <input :ref="makeRef('input','open_date')"
                                                type="text"
                                               :id="open_date.id"
                                               :name="open_date.el"
                                               v-model="elms.open.date.model"
                                               :class="[elms.open.date.element.elmClass.input]"
                                               class="form-control datepicker"
                                               :disabled="elms.open.date.element.disabled ? 'disabled' : null">
                                        <label :ref="makeRef('label','open_date')"
                                               :for="open_date.id">{{labels.startDate}}</label>
                                    </div>
                                </div>
                                <!--open_time-->
                                <div :class="{'col-sm-5':is_data_entry,'col-sm-12':!is_data_entry}">
                                    <div class="md-form">
                                        <i class="material-icons prefix"
                                           :class="[elms.open.time.element.elmClass.icon]">access_time</i>
                                        <input :ref="makeRef('input','open_time')"
                                                type="text"
                                               :id="open_time.id"
                                               :name="open_time.el"
                                               v-model="elms.open.time.model"
                                               :class="[elms.open.time.element.elmClass.input]"
                                               class="form-control timepicker"
                                               :disabled="elms.open.time.element.disabled ? 'disabled' : null">
                                        <label :ref="makeRef('label','open_time')"
                                               :for="open_time.id">{{labels.startTime}}</label>
                                    </div>
                                </div>
                                <!--close_date-->
                                <div class="col-sm-7" v-if="is_data_entry===true">
                                    <div class="md-form">
                                        <i class="material-icons prefix"
                                           :class="[elms.close.date.element.elmClass.icon]">calendar_today</i>
                                        <input  :ref="makeRef('input','close_date')"
                                                type="text"
                                               :id="close_date.id"
                                               :name="close_date.el"
                                               v-model="elms.close.date.model"
                                               :class="[elms.close.date.element.elmClass.input]"
                                               class="form-control datepicker"
                                               :disabled="elms.close.date.element.disabled ? 'disabled' : null">
                                        <label :ref="makeRef('label','close_date')"
                                               :for="close_date.id">{{labels.endDate}}</label>
                                    </div>
                                </div>
                                <!--close_time-->
                                <div :class="{'col-sm-5':is_data_entry,'col-sm-12':!is_data_entry}">
                                    <div class="md-form">
                                        <i class="material-icons prefix"
                                           :class="[elms.close.time.element.elmClass.icon]">access_time</i>
                                        <input  :ref="makeRef('input','close_time')"
                                                type="text"
                                               :id="close_time.id"
                                               :name="close_time.el"
                                               v-model="elms.close.time.model"
                                               :class="[elms.open.time.element.elmClass.input]"
                                               class="form-control timepicker"
                                               :disabled="elms.close.time.element.disabled ? 'disabled' : null">
                                        <label :ref="makeRef('label','close_time')"
                                               :for="close_time.id">{{labels.endTime}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import {DATE_TIME_SEQUENCER_UPDATE, DATE_TIME_SEQUENCER_ENABLE} from '../../config';
    import {uniqueId} from '../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';
    import {PopOver} from '../../../../../app/Shared/Resources/Assets/js/components/PopOver.vue'

    /**
     * @link http://amsul.ca/pickadate.js/api/
     * @link http://weareoutman.github.io/clockpicker/
     */
    export default {
        props: ['content'],
        components: {
            PopOver
        },
        data: function () {
            return {
                enabled: true,
                global_switch_model: '',
                show_app: true,
                popoverRender: false,
                popoverId: '',
                popover: $('[data-toggle="popover"]'),
                popoverContent: {
                    title: 'Info',
                    position: 'top',
                    data_content: 'Default time',
                    icon: 'help_outline',
                    button_text: '',
                    classes: 'white-text'
                },
                readonly: false,
                is_data_entry: false,
                labels: {
                    main: 'available date',
                    startDate: 'date open',
                    endDate: 'date closed',
                    startTime: 'opens at',
                    endTime: 'closes at',
                    class: 'alert alert-info',
                    html: true,
                    description: 'Default open time before the event and close time after the event. Note: this can be overridden',
                    info: 'Set date and time available'
                },
                effect_global: {
                    show_app: true
                },
                effect_globally_id: '',
                open_date: {},
                open_time: {},
                close_date: {},
                close_time: {},
                elms: {
                    open: {
                        date: {
                            model: null,
                            element: {
                                elmClass: {
                                    icon: null,
                                    input: null
                                },
                                obj: null,
                                functionality: null,
                                disabled: false
                            },
                            data: null
                        },
                        time: {
                            model: null,
                            element: {
                                elmClass: {
                                    icon: null,
                                    input: null
                                },
                                obj: null,
                                functionality: null,
                                disabled: true
                            },
                            data: null
                        },
                        data: null
                    },
                    close: {
                        date: {
                            model: null,
                            element: {
                                elmClass: {
                                    icon: null,
                                    input: null
                                },
                                obj: null,
                                functionality: null,
                                disabled: true
                            },
                            data: null
                        },
                        time: {
                            model: null,
                            element: {
                                elmClass: {
                                    icon: null,
                                    input: null
                                },
                                obj: null,
                                functionality: null,
                                disabled: true
                            },
                            data: null
                        },
                        data: null
                    }
                },
                stage: 1
            }
        },

        mounted() {
            this.initialiseDateTimeSequencer();

        },
        created: function () {
            let self = this;
            vueEventHub.$on(DATE_TIME_SEQUENCER_UPDATE, this.updateTimeDetails);
            vueEventHub.$on(DATE_TIME_SEQUENCER_ENABLE, function (val) {
                self.enabled = val;
                if (val === true) {
                    self.initialiseDateTimeSequencer()
                }
            });
        },
        watch: {
            global_switch_model() {
                this.setGlobal();
            },
        },
        methods: {
            makeRef(elm, name) {
                return elm + '-' + name + '--' + this[name].id
            },
            respondToMe() {
            },
            setGlobal() {
            },
            initialiseDateTimeSequencer() {
                let self = this,
                    propsStatic = ['open_date', 'close_date', 'open_time', 'close_time'],
                    propsStaticLen = propsStatic.length,

                    // check if content is set, if not then check if we are using a parent inherited method
                    _targetComponent = (typeof self.content !== 'undefined') ? self.content : self.$parent;

                for (let i = 0; i < propsStaticLen; i++) {
                    let value = propsStatic[i];

                    if (_targetComponent[value]) {
                        let hasProp = _targetComponent[value].hasOwnProperty('value');

                        /**
                         * @param {String} id       Used to identify the element
                         * @param {String} el       The name attribute for the input element
                         * @value {String} value    The value if it has one
                         **/
                        self[value] = {
                            id: _targetComponent[value].id,
                            el: _targetComponent[value].el + '[value]',
                            value: hasProp ? _targetComponent[value].value : null,
                            model: hasProp ? _targetComponent[value].value : null
                        };
                        //populate the previous saved value if there is one
                        if (hasProp) {
                            let valueSplit = value.split('_'),
                                state = valueSplit[0],
                                type = valueSplit[1];

                            self.elms[state][type].model = _targetComponent[value].value;
                        }
                    }
                }

                self.$nextTick(function () {
                    /**
                     * Set initial model values
                     */
                    for (let i = 0; i < propsStaticLen; i++) {
                        let value = propsStatic[i];
                        let modelName = value + '_model';

                        if (self[value].value) {
                            let elmId = self[value].id;
                            //compile the model name
                            // let element = $(`#${self[value].id}`);
                            let element = document.getElementById(elmId);

                            /**
                             * Set the elements value
                             */
                            element.value = self[value].value;

                            /**
                             * Set the label as active
                             */
                            let labelElement = document.querySelector(`#${elmId} + label`);
                            labelElement.classList.add('active');
                            /**
                             * Update the model
                             */
                            self[modelName] = element.value;
                        }
                    }
                    /**
                     * Set the labels
                     * */
                    let labels = ['main', 'startDate', 'endDate', 'startTime', 'endTime', 'description', 'info'];
                    if (_targetComponent.hasOwnProperty('labels')) {
                        $.each(labels, function (index, value) {
                            let hasProp = _targetComponent.labels[value].hasOwnProperty('value');
                            self.labels[value] = _targetComponent.labels[value];
                        });
                    }
                    if (_targetComponent.hasOwnProperty('effect_global')) {
                        this.effect_global = _targetComponent.effect_global;
                        this.effect_globally_id = uniqueId('global-ticket');
                        // console.log('this.effect_global', this.effect_global);
                        if (_targetComponent.effect_global.hasOwnProperty('show_app')) {
                            this.effect_global.show_app = _targetComponent.effect_global.show_app;
                        } else {
                            this.effect_global.show_app = true;
                        }
                    }
                    self.initElements();
                });

                // is this a default setup or a data entry?
                self.is_data_entry = ('is_data_entry' in self.$parent && self.$parent.is_data_entry == true) || false;
            },
            updateTimeDetails(obj) {
                let self = this;
                self.elms.open.time.model = obj.open_time;
                self.elms.close.time.model = obj.close_time;
            },
            getElementById(id) {
                return $(`#${id}`);
            },
            initElements: function () {
                let self = this;
                if (self.is_data_entry) {
                    self.elms.open.date.element.obj = self.getElementById(self.open_date.id);
                    self.elms.close.date.element.obj = self.getElementById(self.close_date.id);
                }
                self.elms.open.time.element.obj = self.getElementById(self.open_time.id);
                self.elms.close.time.element.obj = self.getElementById(self.close_time.id);
                self.createOpenTime();
                self.createCloseTime();

                if (self.is_data_entry) {
                    self.createCloseDate();
                    self.elms.open.date.element.functionality = self.elms.open.date.element.obj.pickadate({
                        min: true, // set limit to today and forward
                        editable: false,
                        onStart: function () {
                            self.elms.open.date.element.obj.removeAttr('readonly');
                        },
                        onSet: function (dateSet) {
                            if (dateSet.hasOwnProperty('clear') && dateSet.clear === null) {

                                self.markDisabled('open', 'time', true);
                                self.markDisabled('close', 'date', true);
                                self.markDisabled('close', 'time', true);
                                self.elms.open.date.model = self.open_date.value = null;
                                return;
                            }
                            let openPicker = self.elms.open.date.element.functionality.pickadate('picker');

                            self.elms.open.date.model = self.open_date.value = openPicker.get();
                            self.elms.open.date.data = dateSet.select;

                            let closeDatePicker = self.elms.close.date.element.functionality
                                                  ? self.elms.close.date.element.functionality.pickadate('picker')
                                                  : null,
                                updateClose = false,
                                closeDateDate = self.elms.close.date.data;
                            if (closeDatePicker) {
                                // set minimum date of close to this value
                                if (closeDateDate) {
                                    if (self.elms.close.date.data < self.elms.open.date.data) {
                                        console.log('self.elms.close.date.data', self.elms.close.date.data);
                                        // must use this because the model is being overridden by the jquery object
                                        updateClose = true;
                                        self.elms.close.date.data = self.elms.open.date.data;
                                    }
                                }

                                closeDatePicker.set({
                                    min: self.elms.open.date.model
                                });
                                self.markDisabled('close', 'date', true);
                                self.markDisabled('close', 'time', true);
                            }

                            /**
                             * Added last to update close model if needed
                             */
                            if (updateClose) {
                                self.elms.close.date.model = self.elms.open.date.model;
                            }
                            self.markDisabled('open', 'time', false);
                            self.elms.open.time.model = self.open_time.value = null;
                        }
                    });
                } else {
                    self.markDisabled('open', 'time', false);
                    self.markDisabled('close', 'time', false);
                    self.elms.open.time.element.obj.removeAttr('readonly');
                    self.elms.close.time.element.obj.removeAttr('readonly');
                }
            },
            createOpenTime: function () {
                let self = this;

                self.elms.open.time.element.functionality = self.elms.open.time.element.obj.pickatime({
                    twelvehour: false,
                    default: 'now',
                    init() {
                        // console.log("clockpicker init()");
                    },
                    beforeShow() {
                        // console.log("before show");
                    },
                    afterDone() {
                        self.elms.open.time.model = self.elms.open.time.element.obj.val();
                        self.elms.open.time.data = self.open_time.value = self.elms.open.time.model;
                        self.elms.open.time.element.elmClass.icon = 'active';

                        if (self.is_data_entry) {
                            self.markDisabled('close', 'date', false);
                            self.isCloseDateTimeLaterThanOpenDateTime();
                        }
                    }
                });
                console.log(self.elms.open.time.element.obj.pickatime)
            },
            createCloseDate: function () {
                let self = this;

                self.elms.close.date.element.functionality = self.elms.close.date.element.obj.pickadate({
                    min: true, // set limit to today and forward
                    editable: false,
                    onStart: function () {
                        // self.elms.close.date.element.obj.removeAttr('readonly');
                    },
                    onSet: function (dateSet) {
                        if (dateSet.hasOwnProperty('clear') && dateSet.clear === null) {
                            self.markDisabled('close', 'time', true);
                            self.elms.close.date.model = self.close_date.value = null;
                            return;
                        }
                        let closePicker = self.elms.close.date.element.functionality.pickadate('picker');

                        self.elms.close.date.model = self.close_date.value = closePicker.get();
                        self.elms.close.date.data = dateSet.select;
                        self.markDisabled('close', 'time', false);
                        self.isCloseDateTimeLaterThanOpenDateTime();
                    }
                });
            },
            createCloseTime: function () {
                let self = this;
                self.elms.close.time.element.functionality = self.elms.close.time.element.obj.pickatime({
                    twelvehour: false,
                    'default': 'now',
                    afterDone() {

                        self.elms.close.time.model = self.elms.close.time.element.obj.val();
                        self.elms.close.time.data = self.close_time.value = self.elms.close.time.model;

                        if (self.is_data_entry) {
                            self.isCloseDateTimeLaterThanOpenDateTime();
                        }
                    }
                });
            },
            isCloseDateTimeLaterThanOpenDateTime: function () {
                let self = this,
                    entity = self.elms.close.time;

                if (!self.elms.close.time.model) {
                    return;
                }
                self.elms.open.data = new Date(`${self.elms.open.date.model} ${self.elms.open.time.model}`).getTime();
                self.elms.close.data = new Date(`${self.elms.close.date.model} ${self.elms.close.time.model}`).getTime();

                if (self.elms.close.data > self.elms.open.data) {
                    entity.element.elmClass.icon = 'active';
                    entity.element.elmClass.input = '';
                    self.markInvalid(entity.element.obj, false);
                } else {
                    entity.element.elmClass.icon = 'red-text';
                    entity.element.elmClass.input = 'invalid';
                    self.markInvalid(entity.element.obj, true);
                    entity.model = self.close_time.value = null;
                }

            },

            /**
             * Marks the element as disabled by setting the disabled attribute to disabled or false
             * @param {String}      state       e.g. close or open
             * @param {String}      type        date or time
             * @param {Boolean|String}      disabled    disabled or false
             */
            markDisabled: function (state, type, disabled) {
//				console.log('state, type, disabled', state, type, disabled);
                /**
                 * set disabled true or false to element
                 */
                this.elms[state][type].element.disabled = disabled;
                /**
                 * if disabled, wipe the element
                 */
                if (disabled) {
                    this.elms[state][type].model = this[`${state}_${type}`].value = null;
                    $(`label[for="${this[`${state}_${type}`].id}"]`).removeClass('active');
                    $(`#${this[`${state}_${type}`].id}`).prev('.active').removeClass('active');

                }
            },
            markInvalid: function (elm, invalid) {
                if (invalid) {
                    elm.addClass('invalid');
                } else {
                    elm.removeClass('invalid');
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/DateTimeSequencer.vue?8323eb16